/**
 * File Preview List Component
 * Shows all selected files before upload
 */

import type { FileUploadState } from '@/types/api.types';
import FilePreviewItem from './FilePreviewItem';

interface FilePreviewListProps {
  files: FileUploadState[];
  onRemove: (fileId: string) => void;
}

const FilePreviewList = ({ files, onRemove }: FilePreviewListProps) => {
  if (files.length === 0) return null;

  return (
    <div className="space-y-2 mb-3">
      {files.map((fileState) => (
        <FilePreviewItem
          key={fileState.id}
          file={fileState.file}
          error={fileState.error}
          progress={fileState.progress}
          onRemove={() => onRemove(fileState.id)}
        />
      ))}
    </div>
  );
};

export default FilePreviewList;
